<ng-container *transloco="let t">
  <ng-template #homeownershipEducation>
    <div class="card shadow-sm mb-5">
      <div class="card-header">
        <h3 class="card-title">{{mainBorrower.firstName + " " + mainBorrower.lastName}}</h3>
      </div>
      <div class="card-body">
        <borrower-homeownership-education #borrowerHomeownershipEducation
          [borrower]="mainBorrower" [defaultToFalse]="!isCompanyPhm"></borrower-homeownership-education>
      </div>
    </div>

    @if (!inCoApplyFlow) {
      @for (coBorrower of coBorrowers; track coBorrower.borrowerId) {
        @if (borrowerSetting(coBorrower)) {
          <div class="card shadow-sm mb-5">
            <div class="card-header">
              <h3 class="card-title">{{coBorrower.firstName + " " + coBorrower.lastName}}</h3>
            </div>
            <div class="card-body">
              <borrower-homeownership-education #borrowerHomeownershipEducation
                [borrower]="coBorrower" [defaultToFalse]="!isCompanyPhm"></borrower-homeownership-education>
            </div>
          </div>
        }
      }

      @if (isInvalid) {
        <div class="d-flex flex-column text-danger">
          <span>{{ t('wizard.homeownership.mustAnswerQuestions') }}</span>
        </div>
      }
    }

  </ng-template>

  <wizard-step-template [stepMainTemplate]="homeownershipEducation" [step]="step" [stepComponent]="this"></wizard-step-template>
</ng-container>
